import {BaseModel} from '../_base/crud';

export const TEAM_TYPE_NOTEAM = 0;
export const TEAM_TYPE_JAPAN = 1;
export const TEAM_TYPE_OVERSEA = 2;
export const teamTypes = [TEAM_TYPE_NOTEAM, TEAM_TYPE_JAPAN, TEAM_TYPE_OVERSEA] as const;
export type TeamType = typeof teamTypes[number];

export class TeamModel extends BaseModel {
    id: number;
    name: string;
    status: number;
    language: string;
    timeZone: string;
    teamType: TeamType;
    countOfMembers: number;

    clear(): void {
        this.id = 0;
        this.name = '';
        this.status = 0;
        this.language = '';
        this.teamType = TEAM_TYPE_JAPAN;
        this.countOfMembers = 0;
    }
}
